import plaidActions from 'core/plaid/actions';
import workflowActions from 'core/workflow/actions';
import dialogActions from 'core/dialogs/actions';
import homeActions from 'core/home/actions';
import uiActions from './actions';
import groupActions from '../groups/actions';
import pageActions from '../page/actions';
import fieldActions from '../fields/actions';
import sessionActions from '../session/actions';
import themeActions from '../theme/actions';

const uiReducer = (state = {}, action) => {
  switch (action.type) {
    case fieldActions.RERENDER:
      return {
        ...state,
        fieldLoading: action.payload.fieldName,
      };
    case fieldActions.RERENDER_SUCCESS:
    case fieldActions.RERENDER_FAILED:
    case fieldActions.RECAPTCHA_SUCCESS:
      return {
        ...state,
        fieldLoading: null,
      };
    case fieldActions.ATOMICFI_GET_TOKEN:
      return {
        ...state,
        fieldLoading: true,
      };
    case fieldActions.ATOMICFI_GET_TOKEN_SUCCESS:
    case fieldActions.ATOMICFI_GET_TOKEN_FAILED:
      return {
        ...state,
        fieldLoading: false,
      };
    case pageActions.GO:
    case pageActions.NEXT:
    case pageActions.SAVE:
    case pageActions.MOBILE_VALIDATION_RESEND:
    case pageActions.MOBILE_VALIDATION_SUBMIT:
    case dialogActions.SEND_CODE:
      return {
        ...state,
        pageLoading: true,
      };
    case groupActions.NEXT:
    case groupActions.SAVE:
    case pageActions.CONTINUE_JOINT:
    case pageActions.INVITE_JOINT:
      return {
        ...state,
        groupLoading: true,
      };
    case pageActions.MOBILE_VALIDATION_SUCCESS:
    case pageActions.GO_FAILED:
    case workflowActions.RESTART_FAILED:
    case groupActions.UPDATE_SUCCESS:
    case groupActions.UPDATE_FAILED:
    case pageActions.MOBILE_VALIDATION_SUBMIT_FAILED:
    case dialogActions.SEND_CODE_SUCCESS:
    case homeActions.GET_PLAID_SUCCESS:
      return {
        ...state,
        appLoading: false,
        groupLoading: false,
        pageLoading: false,
      };
    case pageActions.GO_SUCCESS: {
      if (!action.payload.data.meta.groups) {
        return {
          ...state,
          activePanel: null,
          appLoading: false,
          fieldFocus: null,
          groupLoading: false,
          pageLoading: false,
        };
      }
      if (action.payload.data.meta.page.name === 'launch') {
        return {
          ...state,
          activeGroup: null,
          activePanel: null,
          appLoading: false,
          fieldFocus: null,
          groupLoading: false,
          pageLoading: false,
        };
      }
      const groupOrder = Object.keys(action.payload.data.meta.groups);
      const indexOfCurrentGroup = groupOrder.indexOf(state.activeGroup);
      return {
        ...state,
        activeGroup: action.payload.changeGroup
          ? groupOrder[action.payload.nextGroup ? indexOfCurrentGroup + 1 : 0]
          : state.activeGroup,
        activePanel: null,
        appLoading: false,
        fieldFocus: null,
        groupLoading: false,
        pageLoading: false,
      };
    }
    case pageActions.NEXT_FAILED:
    case groupActions.NEXT_FAILED:
    case plaidActions.UPDATE_META_DONE:
    case plaidActions.LINK_VERIFICATION_SUCCESS:
      return {
        ...state,
        appLoading: false,
        groupLoading: false,
        pageLoading: false,
      };
    case plaidActions.FETCH_ACCOUNTS_SUCCESS:
      if (action.payload.data?.meta?.nextPage) {
        return state;
      }
      return {
        ...state,
        appLoading: false,
        groupLoading: false,
        pageLoading: false,
      };
    case plaidActions.FETCH_ACCOUNTS_FAILED:
    case plaidActions.LINK_VERIFICATION_FAILED:
      return {
        ...state,
        activeGroup: 'FUNDING_AMOUNT',
        appLoading: false,
      };
    case pageActions.START:
    case workflowActions.RESTART:
      return {
        ...state,
        pageLoading: true,
      };
    case pageActions.START_SUCCESS:
      if (action.payload.name === 'qualify') {
        return {
          ...state,
          didStartQualify: true,
        };
      }
      if (action.payload.name === 'autoexport') {
        return {
          ...state,
          didStartAutoexport: true,
        };
      }
      return {
        ...state,
      };
    case homeActions.START_SUCCESS:
    case workflowActions.START_SUCCESS:
      return {
        ...state,
        ...action.payload.searchParams,
      };
    case uiActions.SET_ACTIVE_GROUP:
      return {
        ...state,
        activeGroup: action.payload.groupName,
        activePanel: null,
        appLoading: false,
        groupLoading: false,
        pageLoading: false,
      };
    case uiActions.SET_ACTIVE_PANEL:
      return {
        ...state,
        activePanel: action.payload.panelName,
      };
    case uiActions.SET_MENU_OPEN:
      return {
        ...state,
        menuOpen: action.payload,
      };
    case groupActions.UPLOAD:
    case groupActions.UPDATE:
    case pageActions.DOCUMENT_UPLOAD_NEXT:
    case pageActions.GET_CURRENT:
    case pageActions.ADD_SIGNER_STATUS:
    case pageActions.ADD_BENEFICIARY:
    case pageActions.CONTINUE_USER:
    case pageActions.REMOVE_SIGNER:
    case pageActions.REMOVE_BENEFICIARY:
    case pageActions.ACCEPT_ADDRESS:
    case pageActions.SAVE_SIGNERS:
    case plaidActions.UPDATE_META:
    case plaidActions.LINK_VERIFICATION:
    case plaidActions.FETCH_ACCOUNTS:
    case plaidActions.REFETCH_ACCOUNTS:
    case homeActions.GET_PLAID:
      return {
        ...state,
        appLoading: true,
      };
    case pageActions.STATUS:
      return {
        ...state,
        appLoading: state.activeGroup === 'KBA' && !action.payload.kbaSubmit,
      };
    case groupActions.UPLOAD_SUCCESS:
      return {
        ...state,
        activePanel: action.payload.activePanel,
        appLoading: false,
      };
    case groupActions.UPLOAD_FAILED: {
      const isGroupError =
        action.payload.data.result.msgs['*_PRIMARY_DL'] ||
        action.payload.data.result.msgs['*_SECONDARY_DL'] ||
        action.payload.data.result.msgs['*_SIGNER_DL'];
      const UPLOAD_MAP = {
        PRIMARY_DL: 'PRIMARY_NAME',
        SECONDARY_DL: 'SECONDARY_NAME',
        SIGNER_DL: 'SIGNER_NAME',
      };
      return {
        ...state,
        activeGroup: isGroupError ? state.activeGroup : UPLOAD_MAP[state.activeGroup],
        activePanel: 'back',
        appLoading: false,
      };
    }
    case sessionActions.GET_FAILED:
      return {
        ...state,
        errorPage: action.payload.data,
      };
    case plaidActions.HANDLE_VERIFICATION_QUESTIONS:
      return {
        ...state,
        activeGroup: 'FUNDING_EXT_VERIFICATION',
      };
    case themeActions.GET_SUCCESS:
      return {
        ...state,
        hasTheme: true,
      };
    case fieldActions.SET_FOCUS:
      return {
        ...state,
        fieldFocus: action.payload.fieldName,
      };
    case fieldActions.BLUR:
      return {
        ...state,
        fieldFocus: null,
      };
    case sessionActions.JSC_SUCCESS:
      return {
        ...state,
        deviceToken: action.payload.data,
      };
    case uiActions.SET_APP_LOADING:
      return {
        ...state,
        appLoading: action.payload,
      };
    case uiActions.SET_IS_MOBILE_VERIFICATION_METHOD:
      return {
        ...state,
        isMobileVerificationMethod: action.payload,
      };
    case uiActions.SET_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: action.payload,
      };
    default:
      return state;
  }
};

export default uiReducer;
